import isMobile from 'utils/isMobile';

/* set your data here */
const email = 'jonathan.cochran@gmail.com';
const domain = 'www.pie-path.com'
/* ***************** */

const repository = 'https://github.com/Jonathan-Cochran/pie-career';

const messages = {
  app: {
    crash: {
      title: 'Oooops... Sorry, I guess, something went wrong. You can:',
      options: {
        email: `contact with author by this email - ${email}`,
        reset: 'Press here to reset the application',
      },
    },
  },
  loader: {
    fail: 'Hmmmmm, there is something wrong with this component loading process... Maybe trying later would be the best idea',
  },
  images: {
    failed: 'something went wrong during image loading :(',
  },
  404: 'Hey bro? What are you looking for?',
};

const copyright = {
  title: 'copyright © ',
  link: domain,
};

const themes = {
  light: {
    palette: {
      mode: 'light',
      background: {
        default: '#fafafa',
        paper: '#fff',
      },
      primary: {
        light: '#7986cb',
        main: '#111',
        dark: '#303f9f',
        contrastText: '#fff',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
          },
          contained: {
            backgroundColor: '#1976d2',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#115293',
            },
          },
          outlined: {
            borderColor: '#1976d2',
            color: '#1976d2',
            '&:hover': {
              backgroundColor: 'rgba(25, 118, 210, 0.04)',
              borderColor: '#115293',
            },
          },
          text: {
            color: '#1976d2',
            '&:hover': {
              backgroundColor: 'rgba(25, 118, 210, 0.04)',
            },
          },
        },
      },
    },
  },

  dark: {
    palette: {
      mode: 'dark',
      background: {
        default: '#111',
        paper: '#171717',
      },
      primary: {
        light: '#7986cb',
        main: '#fff',
        dark: '#303f9f',
        contrastText: '#fff',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
          },
          contained: {
            backgroundColor: '#90caf9',
            color: '#000000',
            '&:hover': {
              backgroundColor: '#42a5f5',
            },
          },
          outlined: {
            borderColor: '#90caf9',
            color: '#90caf9',
            '&:hover': {
              backgroundColor: 'rgba(144, 202, 249, 0.08)',
              borderColor: '#42a5f5',
            },
          },
          text: {
            color: '#90caf9',
            '&:hover': {
              backgroundColor: 'rgba(144, 202, 249, 0.08)',
            },
          },
        },
      },
    },
  },
};

const cancelationMessage = 'operation is manually canceled';

const dateFormat = 'MMMM DD, YYYY';

const title = 'PIEpath - Your Road Map to Career Advancement';

const themePair = ['dark', 'light'];

const notifications = {
  options: {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
    autoHideDuration: 3000,
  },
  maxSnack: isMobile ? 3 : 4,
};

const loader = {
  // no more blinking in your app
  delay: 300, // if your asynchronous process is finished during 300 milliseconds you will not see the loader at all
  minimumLoading: 700, // but if it appears, it will stay for at least 700 milliseconds
};

const giphy404 = 'https://giphy.com/embed/14uQ3cOFteDaU';

export {
  messages,
  cancelationMessage,
  dateFormat,
  copyright,
  email,
  domain,
  repository,
  loader,
  title,
  themePair,
  giphy404,
  notifications,
  themes,
};